export default __webpack_public_path__ + "static/15-e847800a781f0b68474b46d72456f728.png";